import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Unlock, BookOpen, TrendingUp } from 'lucide-react';

interface UnlockNotificationProps {
  show: boolean;
  storyTitle: string;
  rewards?: {
    trustBonus?: number;
    unlockNotes?: string;
  };
  onClose: () => void;
  onViewStory: () => void;
}

export const UnlockNotification: React.FC<UnlockNotificationProps> = ({
  show,
  storyTitle,
  rewards,
  onClose,
  onViewStory
}) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 50, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 50, scale: 0.9 }}
          className="fixed bottom-20 left-1/2 transform -translate-x-1/2 z-50"
        >
          <div className="bg-white rounded-2xl shadow-2xl p-6 min-w-80 border-2 border-amber-300">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center">
                <Unlock className="w-8 h-8 text-amber-600 mr-3" />
                <h3 className="text-lg font-bold text-gray-800">解锁新内容！</h3>
              </div>
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-600 transition"
              >
                ✕
              </button>
            </div>

            <div className="mb-4">
              <h4 className="font-semibold text-gray-700 mb-2">{storyTitle}</h4>
              <p className="text-sm text-gray-600">现可在海龟汤模式中游玩</p>
            </div>

            {rewards && (
              <div className="space-y-2 mb-4">
                {rewards.trustBonus && (
                  <div className="flex items-center text-sm">
                    <TrendingUp className="w-4 h-4 text-green-600 mr-2" />
                    <span className="text-green-600">信任度 +{rewards.trustBonus}</span>
                  </div>
                )}
                {rewards.unlockNotes && (
                  <div className="flex items-start text-sm">
                    <BookOpen className="w-4 h-4 text-blue-600 mr-2 mt-0.5" />
                    <span className="text-blue-600">{rewards.unlockNotes}</span>
                  </div>
                )}
              </div>
            )}

            <div className="flex space-x-3">
              <button
                onClick={onViewStory}
                className="flex-1 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition font-medium"
              >
                立即游玩
              </button>
              <button
                onClick={onClose}
                className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition"
              >
                稍后
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};